import IframeActivity from "./IframeActivity";

export default function PackItUp() {
    return (
        <IframeActivity
            src="/activities/pack-it-up/index.html"
            title="Pack It Up"
        />
    );
}